import BaseQueryControlComponent from './BaseQueryControlComponent'
import React from 'react'
import {browserHistory} from 'react-router'
import {Input} from 'react-bootstrap'
import {t} from '../../helpers/translate'

class LimitComponent extends BaseQueryControlComponent {

  changeLimit(event) {
    this.props.currentLimit ? this.updateCurrentQuery({
      limit: event.target.value,
      page: 1
    })
    :
    this.updateCurrentQuery({
      receivedLimit: event.target.value,
      receivedPage: 1
    })
  }

  render() {
    const key = this.props.currentLimit ? 'limit' : 'receivedLimit';
    return <div className="row">
      <div className="col-sm-6 form-control-static"><b> {t('Results per Page')}</b></div>
      <div className="col-sm-5"><Input type="select" value={this.getQueryParam(key)} onChange={this.changeLimit.bind(this)}>{[10, 25, 50, 100].map((n, i) =>
        <option key={i} value={n}>{n}</option>)}</Input></div>

    </div>
  }
}
LimitComponent.displayName = 'LimitComponent';
export default LimitComponent;



// WEBPACK FOOTER //
// ./src/components/common/LimitComponent.js